<template>
    <div class="container is-centered sign-in">
        <SignInForm :mode="routerName"
                    header-title="Password Reset"
                    button-title="Submit"
                    show-errors
        />
    </div>
</template>

<script>
    import SignInForm from '@/components/SignInForm.vue'

    export default {
        name: "PasswordReset",
        components: {SignInForm},
        computed: {
            routerName() {
                return this.$route.name;
            }
        }
    }
</script>

<style scoped>

</style>
